import { render, staticRenderFns } from "./Shield.vue?vue&type=template&id=0bb4b57a&scoped=true&"
import script from "./Shield.vue?vue&type=script&lang=js&"
export * from "./Shield.vue?vue&type=script&lang=js&"
import style0 from "./Shield.vue?vue&type=style&index=0&id=0bb4b57a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4b57a",
  null
  
)

export default component.exports